import { Col, Row } from "antd";
import { useGetInvites } from "./ServerSideStates";
import ListItems from "./Components/ListItems";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import TopFilters from "./Components/TopFilters";
import PageTitle from "apps/Common/PageTitle";
import MobileTopFilters from "./Components/MobileTopFilters";
import { Helmet } from "react-helmet-async";

const InvitesIndex = () => {
  const { filter } = useSelector((state: RootState) => state.invite);
  const invites = useGetInvites(filter);

  return (
    <>
      <Col xs={24} className="!p-0" >
        <Row
          gutter={[
            { xs: 10, md: 10, xl: 10 },
            { xs: 10, md: 15, xl: 20 }
          ]}
          className="">
          <Col xs={12} md={24} className="!flex md:justify-center justify-start items-center">
            <Helmet>
              <title className="capitalize">{"Davet Listesi"}</title>
            </Helmet>
            <div className="items-center">
<PageTitle
              title="Davet Listesi"
              count={invites?.data?.data?.length || 0}
            />
            <div className="text-gray-500 text-[12px]">(Mağaza Davetleri)</div>
            </div>
            
          
           
          </Col>
          <Col xs={12} md={24} className=" md:!hidden !flex justify-end items-center" >
            <MobileTopFilters />
          </Col>
          <Col xs={24} className="!hidden md:!block" >
            <TopFilters isMobile={false} />
          </Col>

          <Col xs={24} className="">
            <ListItems />
          </Col>
        </Row>
      </Col>
      <></>
    </>
  );
};

export default InvitesIndex;
